unit PrepareOperationMedicineItemType;
{

/* Initial. */

}
interface

type
  TPrepareOperationMedicineItemType = class
  private
    fPrepareOperationMedicineKey: String;
    fPrepareOperationName: String;
    fMedicineName: String;
    fAmountInPrepareOperation: Byte;
  public
    property PrepareOperationMedicineKey: String read fPrepareOperationMedicineKey;
    property PrepareOperationName: String read fPrepareOperationName;
    property MedicineName: String read fMedicineName;
    property AmountInPrepareOperation: Byte read fAmountInPrepareOperation;
  end;

implementation

end.
